<template>
  <div class="selects-model">
    <div class="selects-model-title" v-if="title">{{ title }}</div>
    <div class="selects-model-list">
      <selectsItem
        v-for="item in parseList"
        :key="item.value"
        :size="size"
        :href="item.href"
        :selected="item.selected"
        @click.native.prevent="handleClick(item)"
      >
        <span class="select-item-slot">{{ item.name }}</span>
      </selectsItem>
    </div>
  </div>
</template>

<script>
import selectsItem from 'app/web/component/consult/listCommon/selectsItem.vue'
export default {
  components: {
    selectsItem
  },
  props: {
    value: {
      type: Object
    },
    title: {
      type: String
    },
    size: {
      type: Number
    },
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  methods: {
    handleClick(item) {
      !item.clear && item.alowMultiple
        ? this.$emit('multipleChange', {
            [item.type]: item.value
          })
        : this.$emit('change', {
            [item.type]: item.value
          })

      item.stat && this.eventStat(item.stat)
    }
  },
  computed: {
    parseList() {
      return this.list.map(v => {
        let selected = false

        if (v.alowMultiple) {
          if (!this.value[v.type] && !v.value) {
            selected = true
          } else {
            let s = (this.value[v.type] || '').split(',')
            selected = !!s.find(item => item === v.value)
          }
        } else {
          selected = this.value[v.type] == v.value
        }

        return Object.assign(
          {
            selected
          },
          v
        )
      })
    }
  }
}
</script>

<style lang="scss">
.selects-model {
  padding-top: 15px;
  &-list {
    display: flex;
    flex-wrap: wrap;
    padding: 15px 20px 30px;
  }
  &-title {
    line-height: 1.25;
    padding: 0 30px;
    font-size: 28px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 700;
    color: #21252d;
  }
  .select-item-slot {
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
  }
}
</style>
